module.exports = __webpack_public_path__ + "static/media/BY.2c5cd0bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/countryFlags/BY.svg
// module id = 1891
// module chunks = 0